import { AgResourceLanguage } from '../types';
import { checkout as EnUsCheckout } from '../en-us/checkout';

export const checkout: AgResourceLanguage['checkout'] = {
  ...EnUsCheckout,
  paymentExpress: {
    title: 'Paiement Express',
    caption: 'ou continuez ci-dessous pour payer par carte de crédit'
  },
  summaryBlock: {
    title: {
      desktopView: 'Récapitulatif de la commande',
      mobileView: 'Récapitulatif'
    },
    productsOrderSummary: {
      showProduct: 'Afficher le récapitulatif de la commande',
      label: 'Produits',
      hideProduct: 'Masquer le récapitulatif de la commande',
      gift: 'Cadeau Gratuit',
      giftPrice: 'Gratuit',
      shipsEvery: 'Expédié tous les',
      shipsOneTime: 'Expédié une seule fois',
      frequencyUnit: 'jours',
      welcomeKitRemoved: `
        <p>
          Bienvenue à nouveau !
          <br>Désolé, notre kit de bienvenue est réservé aux nouveaux clients. Besoin d'un remplacement ? Contactez notre équipe de Customer Happiness.
        </p>
      `
    }
  },
  paymentFields: {
    paymentTitle: 'Paiement',
    paymentReviewTitle: 'Paiement',
    paymentReviewButton: 'Modifier',
    paymentPageContinueButton: 'Revoir la commande',
    creditCardLabel: 'Carte de crédit',
    creditCardReviewText: '{{brand}} se terminant par {{last4}}',
    creditCardCustomError: 'Les informations de votre carte sont incomplètes.',
    sepaLabel: 'Prélèvement SEPA',
    sepaReviewText: 'SEPA se terminant par {{name}}',
    sepaDisclaimer: `
      J'autorise par la présente Athletic Greens (EU) Limited à prélever des paiements de mon compte via prélèvement automatique.
      En cas d'abonnement, cette autorisation vaut pour des paiements récurrents.
      J'instruis ma banque d'honorer les prélèvements automatiques d'Athletic Greens (EU) Limited.
      Je suis d'accord pour que le délai de notification préalable légale pour le prélèvement automatique soit réduit à un jour.
      Remarque : je peux récupérer le montant prélevé dans les 8 semaines, à compter de la date de prélèvement respective.
      Les termes convenus avec ma banque s'appliquent.
    `,
    paymentPageWalletsFields: {
      deleteButton: 'Supprimer',
      label: 'Détails de paiement'
    },
    walletsTotalLabel: 'Total'
  },
  shippingFields: {
    subTitle: 'Informations de livraison',
    caption: 'Votre commande sera expédiée sous 3 à 5 jours ouvrables.',
    email: 'E-mail',
    countryRegion: 'Pays/région',
    firstName: 'Prénom',
    lastName: 'Nom',
    addressLine1: 'Adresse',
    addressLine2: 'Appartement, Suite, Etc',
    city: 'Ville',
    state: 'Province',
    zipCode: 'Code postal',
    phone: 'Téléphone',
    pccc: 'PCCC/Numéro de passeport',
    isCreateAccount: 'Restez engagé avec des conseils, de l’inspiration et la communauté.',
    submitButtonText: 'Passer au paiement',
    freeSubmitButtonText: 'Revoir la commande',
    reviewTitle: 'Livraison',
    reviewButton: 'Modifier',
    subscribeOnSms: `
      <p>
        <strong>Envoyez-moi un SMS lorsque mon AG1 est expédié et sur du contenu exclusif sur la santé et la science.</strong> 
        J'accepte de recevoir automatiquement des messages marketing par SMS de DrinkAG1 au numéro que j'ai fourni ci-dessus.
        Le consentement n'est pas une condition d'achat. Des frais de message et de données peuvent s'appliquer. Répondez AIDE ou STOP pour vous désinscrire. 
        Consultez nos <a href="https://drinkag1.com/text-message-terms/" target="_blank" rel="noopener">Conditions SMS</a>, 
        <a href="https://drinkag1.com/privacy/" target="_blank" rel="noopener">Politique de confidentialité</a> et 
        <a href="https://drinkag1.com/terms-and-conditions/" target="_blank" rel="noopener">Conditions générales</a>.
      </p>
    `
  },
  placeOrderFields: {
    continueButton: 'Passer la commande',
    otpCaption: `
      <p>En passant cette commande, vous acceptez les 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Conditions générales</a> 
        et&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Politique de confidentialité</a>.
      </p>
    `,
    subscriptionCaption: `
      <p>
        En passant cette commande, vous acceptez les 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Conditions générales</a> 
        et&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Politique de confidentialité</a>.
        <br><br>
      </p>
      <p>
        Vous achetez un abonnement récurrent. Vous autorisez Athletic Greens à débiter la méthode de paiement enregistrée tous les 30 jours au tarif en vigueur. Votre abonnement sera renouvelé tous les 30 jours
        jusqu'à ce que vous l'annuliez. Vous pouvez annuler à tout moment avant votre prochaine expédition
        en visitant votre compte ou en envoyant un e-mail à <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
      </p>
    `
  },
  thanksFields: {
    accountPasswordLabel: 'Mot de passe',
    minLength: 'Au moins 8 caractères',
    maxLength: 'Le mot de passe est trop long (maximum 40 caractères)',
    whitespace: 'Le mot de passe commence ou se termine par des espaces',
    uppercase: '1 majuscule',
    lowercase: '1 minuscule',
    number: '1 chiffre',
    accountButtonLabelCreate: 'Créer un compte',
    accountButtonLabelVisit: 'Visitez mon compte',
    accountButtonLabelError: 'Visitez mon compte',
    successMessage: `
      <h1>Bienvenue à la Nutrition Fondamentale, {{customerFirstName}} !</h1>
      <p>La confirmation a été envoyée à : {{customerEmail}}</p>
    `,
    errorMessage: `
      <h1>Bienvenue chez AG1</h1>
      <p>Connectez-vous pour gérer votre compte, suivre vos commandes et acheter des produits exclusifs.</p>
    `,
    orderDetails: `
      <p><strong>Numéro de commande :</strong> #{{orderId}}</p>
      <p><strong>Livré à :</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    accountTitleNotCreated: `
      <h2>Créer un compte</h2>
      <p>Vérifiez le statut de la commande, suivez les expéditions et plus encore.</p>
    `,
    accountTitleCreated: `
      <h2>Créer un compte</h2>
      <p>Vérifiez le statut de la commande, suivez les expéditions et plus encore.</p>
    `
  },
  unifiedOrderReview: {
    backButton: 'Retour à la boutique',
    shippingFieldsTitle: 'Informations de livraison',
    shippingMethodSubTitle: 'Méthode de livraison',
    frequencySubTitle: 'Fréquence de livraison',
    frequencyText: 'Tous les {{frequency}}',
    frequencyUnit: 'jours',
    paymentTitle: 'Paiement',
    paymentSubTitle: 'Mode de paiement',
    billingAddressSubTitle: 'Adresse de facturation',
    billingAddressDescription: 'Identique à l’adresse de livraison',
    placeOrderButton: 'Passer la commande',
    commonCaption: `
    <p>
      Vous achetez un abonnement récurrent. Vous autorisez Athletic Greens à débiter la méthode de paiement enregistrée tous les {{order_frequency_days}} jours au tarif en vigueur.
      Votre abonnement sera renouvelé tous les {{order_frequency_days}} jours jusqu'à ce que vous l'annuliez.
      Vous pouvez annuler à tout moment avant votre prochaine expédition en visitant votre compte ou en envoyant un e-mail à <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
    </p>
  `,
    giftTitle: 'Envoyer en tant que cadeau',
    giftRecipientEmailLabel: 'E-mail du destinataire*',
    giftMessageLabel: 'Message cadeau',
    shippingAddressTitle: 'Informations de livraison',
    shippingAddressText: 'Ajoutez le nom et l’adresse du destinataire'
  },
  thanksFieldsMembers: {
    successMessage: `
      <h1>Hourra, votre commande est passée !</h1>
      <p>La confirmation a été envoyée à : {{customerEmail}}</p>
    `,
    successMessageGift: `
      <h1>Hourra, votre commande cadeau est confirmée !</h1>
      <p>Un e-mail de confirmation de commande a été envoyé à : {{customerEmail}} et {{giftRecipientEmail}}</p>
    `,
    successMessageFreeGift: `
      <h1>Merci d'avoir partagé !</h1>
      <p>L'e-mail de confirmation a été envoyé à : {{customerEmail}} et {{giftRecipientEmail}}</p>
    `,
    orderDetails: `
      <p><strong>Numéro de commande :</strong> #{{orderId}}</p>
      <p><strong>Livré à :</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    giftOrderDetails: `
      <p><strong>Numéro de commande :</strong> #{{orderId}}</p>
      <p><strong>Type de commande :</strong> Partager des packs gratuits</p>
      <p><strong>Total :</strong> {{total}}</p>
      <p><strong>Livré à :</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
      <p>{{email}}</p></div>
    `,
    giftOrderDetailsPaid: `
    <p><strong>Numéro de commande :</strong> #{{orderId}}</p>
    <p><strong>Livré à :</strong> {{customerName}}</p>
    <p><strong>E-mail :</strong> {{email}}</p>
    <p>{{address}}</p></div>
    `,
    viewOrderButtonLabel: 'Voir les détails de la commande',
    shareMorePacksButtonLabel: 'Partager plus de packs',
    giftMessageTitle: 'Message cadeau :'
  },
  // Si Sanity ne fonctionne pas
  header: {
    title: 'CAISSE',
    editOrder: 'Modifier la commande'
  },
  footer: {
    links: [
      { url: 'https://drinkag1.com/privacy', target: true, text: 'Politique de confidentialité' },
      {
        url: 'https://drinkag1.com/terms-and-conditions',
        target: true,
        text: 'Conditions générales'
      }
    ]
  }
};
